import ColumnSettingsView from "./ColumnSettingsView";

export default ColumnSettingsView;
